import { render, staticRenderFns } from "./roleEdit.vue?vue&type=template&id=423543e6&scoped=true"
import script from "./roleEdit.vue?vue&type=script&lang=js"
export * from "./roleEdit.vue?vue&type=script&lang=js"
import style0 from "./roleEdit.vue?vue&type=style&index=0&id=423543e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423543e6",
  null
  
)

export default component.exports